var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAndroid && _vm.deferredPrompt && !_vm.isInStandaloneMode)?_c('v-btn',{staticStyle:{"width":"fit-content"},attrs:{"small":"","color":"#fff","elevation":"0"},on:{"click":_vm.installApp}},[_c('v-icon',{attrs:{"color":"#101010"}},[_vm._v("\n    mdi mdi-download\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }